import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InventoryService } from '@app/shared/services/inventory.service';

@Component({
  selector: 'app-inventory-listiii',
  templateUrl: './inventory-listiii.component.html',
  styleUrls: ['./inventory-listiii.component.css']
})
export class InventoryListiiiComponent implements OnInit {

  inventoryMaterials: any[] = [];
  totalBalance: number = 0;
  totalInput: number = 0;
  totalOutput: number = 0;
  codePrefix : string = '30';

  selectedSubcategory: string;
  materials: any[] = [];

  constructor(
    private acRoute: ActivatedRoute,
    private inventoryService: InventoryService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.acRoute.queryParams.subscribe(params => {
      this.selectedSubcategory = params['subCategory'];
      this.fetchMaterials(this.selectedSubcategory);
    });
  }

  fetchMaterials(subcategory: string): void {
    this.inventoryService.getAllInventry().subscribe(
      (data: any[]) => {
        // Filter materials based on the received subcategory
        this.materials = data.filter(item => item.subcategory === subcategory);
       
        this.cdr.detectChanges();
      },
      (error) => {
        console.error('Error fetching inventory materials:', error);
      }
    );
  }

  calculateTotalInput(SubcategoryOrMaterial: string): number {
    return this.materials
      .filter(item => item.subcategory === SubcategoryOrMaterial || item.material === SubcategoryOrMaterial)
      .reduce((acc, item) => acc + (item.qty || 0), 0);
  }
  
  calculateTotalOutput(SubcategoryOrMaterial: string): number {
    return this.materials
      .filter(item => item.subcategory === SubcategoryOrMaterial || item.material === SubcategoryOrMaterial)
      .reduce((acc, item) => acc + (item.output || 0), 0);
  }
  
  calculateTotalBalance(SubcategoryOrMaterial: string): number {
    const totalInput = this.calculateTotalInput(SubcategoryOrMaterial);
    const totalOutput = this.calculateTotalOutput(SubcategoryOrMaterial);
    return totalInput - totalOutput;
  }
  
  

  viewDetails(material: any): void {
    console.log('Viewing details of material:', material);
    // Add your navigation logic here if needed
  }

  onNextButtonClick(material: any): void {
    // Add logic to navigate to the next page with the selected material
    console.log('Navigating to the next page with material:', material);
  }
}
